export type StatusLink = 'AGUARDANDO' | 'PAGO' | 'RECUSADO' | 'DEVOLVIDO' | 'EXPIRADO';

export interface LinkPagamentoItem {
  id: string;
  url: string;
  descricao: string;
  valorCartao: string;
  valorParcela: string;
  parcelas: number;
  valorPix: string;
  comTaxas: boolean;
  expiraEm: string;
  createdAt: string;
  status: StatusLink;
  pagoEm: string | null;
  parcelasPagas: number | null;
  valorPago: string | null;
  valorLiquido: string | null;
  consultor: string;
  lead: { id: string; nome: string } | null;
  venda: { id: string; numero: number | null; clienteNome: string } | null;
  temParcela: boolean;
  baixa: { em: string | null; erro: string | null } | null;
}

export interface ParcelaVenda {
  id: string;
  indice: number;
  valor: number;
  pago: number;
  naoPago: number;
  status: string;
  metodo: string | null;
  vencimento: string | null;
  aberta: boolean;
  cartao: boolean;
  linkId: string | null;
}

/** Nome da forma de pagamento como aparece no Conta Azul. */
export function nomeMetodo(m: string | null): string {
  if (!m) return 'Não informada';
  const map: Record<string, string> = {
    CARTAO_CREDITO: 'Cartão de crédito',
    CARTAO_CREDITO_VIA_LINK: 'Cartão de crédito (link)',
    LINK_PAGAMENTO: 'Link de pagamento',
    PIX_PAGAMENTO_INSTANTANEO: 'Pix',
    PIX_COBRANCA: 'Pix (cobrança Conta Azul)',
    COBRANCA_PIX: 'Pix (cobrança Conta Azul)',
    BOLETO_BANCARIO: 'Boleto',
    DINHEIRO: 'Dinheiro',
    TRANSFERENCIA_BANCARIA: 'Transferência',
    CARTAO_DEBITO: 'Cartão de débito',
    CARTEIRA_DIGITAL: 'Carteira digital',
  };
  return map[m] ?? m.replace(/_/g, ' ').toLowerCase().replace(/^./, (c) => c.toUpperCase());
}

export const STATUS_LINK: Record<StatusLink, { label: string; tone: string }> = {
  AGUARDANDO: { label: 'Aguardando pagamento', tone: 'amber' },
  PAGO: { label: 'Pago', tone: 'green' },
  RECUSADO: { label: 'Pagamento recusado', tone: 'orange' },
  DEVOLVIDO: { label: 'Devolvido', tone: 'pink' },
  EXPIRADO: { label: 'Expirado', tone: 'gray' },
};
